import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import eventbus from 'vue3-eventbus';
import moment from 'moment/src/moment'
import jwt_decode from "jwt-decode";

import { IonicVue } from '@ionic/vue';
import { createI18n } from 'vue-i18n'
import messages from './i18n'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import '@ionic/pwa-elements';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

defineCustomElements(window);

/* Theme variables */
import './theme/variables.css';

/** permission control */
import './permission';

// create vue-i18n object
const i18n = createI18n({
  legacy: false,
  // something vue-i18n options here ...
	locale: 'vi',
  // fallbackLocale: 'en',
  messages
})

const app = createApp(App).use(IonicVue).use(store).use(router).use(eventbus).use(moment).use(i18n);
app.provide('$moment', moment)
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$eventBus = eventbus;
app.config.globalProperties.$jwtDecode = jwt_decode;

router.isReady().then(() => {
	app.mount('#app');
});
